import React from 'react';
import { Chip, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { OrderPageData } from '../../../api';
import { useLanguage } from '../../../utils/GeneralUtils';
import { useAccountData } from '../../StorefrontThemeWrapper';
import { useStartingPriceLabel } from '../../common/storefrontPriceUtils';

interface TrialCardProps {
  orderPage: OrderPageData;
}

export const TrialCard = ({ orderPage }: TrialCardProps) => {
  const { accountId, storefrontId } = useParams();
  const [searchParams] = useSearchParams();
  const account = useAccountData();
  const { t } = useTranslation();
  const language = useLanguage();

  const { label: priceLabel, startingPrice } = useStartingPriceLabel(orderPage, account);
  const showPrice = startingPrice > 0 && !searchParams.has('hp');
  const trialSearchParams = new URLSearchParams(searchParams);
  trialSearchParams.set('trial', '1');

  return (
    <Link
      to={{
        pathname: `/experience/${accountId}/${orderPage.id}/${storefrontId || ''}`,
        search: trialSearchParams.toString(),
      }}
      style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
      <Grid
        container
        alignItems="center"
        flexWrap="nowrap"
        sx={{
          px: 3,
          py: 3,
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          overflow: 'hidden',
          transition: 'background-color 0.15s',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}>
        <Grid sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              lineHeight: 1.3,
              overflowWrap: 'anywhere',
            }}>
            {orderPage.label?.[language]}
          </Typography>
          <Chip
            label={t('storefront.trialSessions')}
            size="small"
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              fontWeight: 500,
            }}
          />
        </Grid>
        {showPrice && (
          <Grid sx={{ ml: 2, flexShrink: 0, textAlign: 'right' }}>
            <Typography variant="body2" sx={{ fontWeight: 700, color: 'primary.main', whiteSpace: 'nowrap' }}>
              <bdi>{priceLabel}</bdi>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Link>
  );
};
